export default __webpack_public_path__ + "static/media/key-areas.3b0531cd.png";